// extracted by mini-css-extract-plugin
module.exports = {"section__form":"styles_section__form__uFJYk","pulse":"styles_pulse__4v0VF","jump":"styles_jump__Li7_V","wiggle":"styles_wiggle__v22Ko"};